/**
 * @description Component-StepRatioSelector
 */
import './index.less';

import { FC, useCallback, useEffect, useMemo, useState } from 'react';

import { Select } from '@/components/Select';
import { DEFAULT_STEP_RATIO } from '@/constants/trade';
import { usePairStepRatios } from '@/features/trade/hooks';

import DownIcon from '@/assets/svg/dropdown.svg?react';
import { SelectProps } from 'antd/es/select';
import classNames from 'classnames';
interface IPropTypes {
  className?: string;
  imr: number | undefined;
  onChange: (value: number) => void;
  withBaseBPs?: boolean;
  numbersOverride?: number[];
  defaultStepRatioOverride?: number;
  stepRatio?: number;
  popupClassName?: string;
}
// base 10000
const StepRatioSelector: FC<IPropTypes & SelectProps> = function ({
  imr,
  dropdownStyle,
  onChange,
  dropdownAlign = { points: ['tr', 'br'], offset: [0, 12] },
  withBaseBPs,
  numbersOverride,
  defaultStepRatioOverride,
  popupMatchSelectWidth,
  stepRatio,
  popupClassName,
}) {
  const defaultStepRatio = defaultStepRatioOverride || DEFAULT_STEP_RATIO;
  const [value, setValue] = useState(stepRatio || defaultStepRatio);
  const numbers = usePairStepRatios(imr, withBaseBPs);

  useEffect(() => {
    if (stepRatio) setValue(stepRatio);
  }, [stepRatio]);

  const handleChange = useCallback(
    (newValue: number) => {
      setValue(newValue);
      onChange(newValue);
    },
    [onChange],
  );

  const effectiveNumbers = numbersOverride || numbers;
  const options = useMemo(
    () => effectiveNumbers.map((n) => ({ value: n, label: `${n / 100}%` })),
    [effectiveNumbers],
  );
  return (
    <Select
      suffixIcon={<DownIcon className="syn-step-ratio-selector-icon" />}
      options={options}
      value={value}
      popupClassName={classNames('syn-step-ratio-selector-popup', popupClassName)}
      onChange={handleChange}
      placement="bottomRight"
      popupMatchSelectWidth={popupMatchSelectWidth}
      dropdownStyle={dropdownStyle}
      dropdownAlign={dropdownAlign}
      className="syn-step-ratio-selector"
    />
  );
};

export default StepRatioSelector;
